import { render, staticRenderFns } from "./CalendarActivityHeader.vue?vue&type=template&id=50b895cb&scoped=true&"
import script from "./CalendarActivityHeader.vue?vue&type=script&lang=js&"
export * from "./CalendarActivityHeader.vue?vue&type=script&lang=js&"
import style0 from "./CalendarActivityHeader.vue?vue&type=style&index=0&id=50b895cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b895cb",
  null
  
)

export default component.exports